import {Table} from "@hosttools/frontend/components";

export default Table;
